import BookmarkConstants from '../constants/BookmarkConstants';
import PaginatedStore from './PaginatedStore';
import InventoryRecord from '../models/InventoryRecord';

class BookmarkStore extends PaginatedStore {
  static storeName = 'BookmarkStore';
  static handlers = {
    [BookmarkConstants.CREATE_BOOKMARK_START]   :  'fetchEntityStart',
    [BookmarkConstants.CREATE_BOOKMARK_SUCCESS] :  'fetchEntitySuccess',
    [BookmarkConstants.CREATE_BOOKMARK_FAILURE] :  'fetchEntityFailure',
    [BookmarkConstants.LIST_BOOKMARKS_START]    :  'listEntitiesStart',
    [BookmarkConstants.LIST_BOOKMARKS_SUCCESS]  :  'listEntitiesSuccess',
    [BookmarkConstants.LIST_BOOKMARKS_FAILURE]  :  'listEntitiesFailure',
    [BookmarkConstants.DELETE_BOOKMARK_START]   :  'deleteEntityStart',
    [BookmarkConstants.DELETE_BOOKMARK_SUCCESS] :  'deleteEntitySuccess',
    [BookmarkConstants.DELETE_BOOKMARK_FAILURE] :  'deleteEntityFailure'
  };
  static defaultPagination = { offset: 0, limit: 10 };
  static defaultSorter = undefined;
  static entityModel = InventoryRecord;

  getCurrentInventoryRecords() {
    return this.orderedEntities;
  }

  fetchEntitySuccess(data) {
    super.fetchEntitySuccess(data.inventoryRecord);
  }

  deleteEntitySuccess(data) {
    if(this.currentPagination.totalResults) {
      this.currentPagination.totalResults -= 1;
    }
    super.deleteEntitySuccess(data.inventoryRecord.id);
  }
}

export default BookmarkStore;



// WEBPACK FOOTER //
// banquet/stores/BookmarkStore.js